import { useEffect, useState } from 'react';
import { useClient } from 'hooks/useClient';
import { useQuery } from 'react-query';
import fp from 'lodash/fp';
import { resolveTokenV3 } from 'helpers/sessionContext';
import { useSession } from 'store/session';
import { IInvite } from '@cincel/client';

export const useFetchInvites = ({ folder, document, team, token, enabled }) => {
  const client = useClient({
    url: process.env.REACT_APP_API_V3,
    token: resolveTokenV3(token),
  });

  const [like, setLike] = useState<null | string>(null);

  const [pageSize, setPageSize] = useState<number>(50);

  const [page, setPage] = useState<number>(1);

  const { team: defaultTeam } = useSession();

  const teamUUID = defaultTeam?.uuid as string;

  const resolvedToken = resolveTokenV3(token);

  const finalTeam = team ?? teamUUID;

  const query = useQuery(
    ['fetch-document-invites', finalTeam, folder, document, resolvedToken],
    async () => {
      const response = await client.getDocumentInvitationsV3(
        finalTeam,
        folder,
        document,
        {
          name_like: !fp.isEmpty(like) ? like : null,
          limit: pageSize,
          page,
          sort: 'email',
          order: 'ASC',
        },
      );

      return {
        count: fp.get(['headers', 'x-total-count'])(response),
        data: fp.get('data')(response) as IInvite[],
      };
    },
    {
      enabled: Boolean(enabled && finalTeam && folder && document && resolvedToken),
    },
  );

  useEffect(() => {
    if (query?.isFetchedAfterMount) query?.refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [like, page, pageSize]);

  return { ...query, like, page, setLike, setPage, pageSize, setPageSize };
};
